import useCompanyContext from 'common/hooks/useCompanyContext';
import { useCompanyProfile } from 'common/hooks/useCompanyProfile';

import { CompanyMandatoryData } from '../types';

export const useCompanyDetails = () => {
  const { companyProfileId } = useCompanyContext();
  const { company, loading } = useCompanyProfile(companyProfileId);

  const mandatoryData: Record<CompanyMandatoryData, string | null> = {
    [CompanyMandatoryData.REGISTRATION_DATE]: company
      ? company.registrationDate
      : '',
    [CompanyMandatoryData.ZIP]: company ? company.zip : '',
  };
  const missingData: CompanyMandatoryData[] = [];

  for (const [key, value] of Object.entries(mandatoryData)) {
    if (value === '') {
      missingData.push(key as CompanyMandatoryData);
    }
  }

  return {
    company,
    loading,
    missingData,
  };
};
